import { render, staticRenderFns } from "./LexinKeyboardLangKmr.vue?vue&type=template&id=34bb423d&"
import script from "./LexinKeyboardLangKmr.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangKmr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports